module.exports = __webpack_public_path__ + "media/images/code_1-5ec5579f4a9125d83c630eb636337143.png";